import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, Card, EmptyState } from "../components/common";
import { ClockCounterClockwise } from "@phosphor-icons/react";

export default function Auditoria() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader overline="Trazabilidad" title="Auditoría" />
      {items.length === 0 ? (
        <EmptyState icon={ClockCounterClockwise} title="Sin registros" subtitle="Aquí se registran las acciones clave: contratos, estimaciones/pagos y órdenes de cambio." />
      ) : (
        <Card className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border text-left">
                {["Fecha", "Usuario", "Rol", "Acción", "Entidad", "Detalle"].map((h) => <th key={h} className="px-4 py-3 overline">{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {items.map((a, i) => (
                <tr key={i} data-testid={`audit-row-${i}`} className="border-b border-border last:border-0 hover:bg-muted/50 transition-colors duration-150">
                  <td className="px-4 py-3 whitespace-nowrap text-muted-foreground">{new Date(a.at).toLocaleString("es-MX")}</td>
                  <td className="px-4 py-3 font-medium">{a.user}</td>
                  <td className="px-4 py-3 capitalize text-muted-foreground">{a.role}</td>
                  <td className="px-4 py-3 capitalize">{a.action}</td>
                  <td className="px-4 py-3 capitalize">{a.entity}</td>
                  <td className="px-4 py-3 text-muted-foreground">{a.detail}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}
